import React from "react";

import { useNavigate } from "react-router-dom";
import { makeStyles } from "tss-react/mui";

import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";

import ButtonUI from "./ButtonUI";

const useStyles = makeStyles()({
  Image: {
    height: "150px",
    widht: "150px",
  },
  Container: {
    height: "100vh",
    widht: "100v%",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    flexDirection: "column",
    backgroundColor: "#FAFAFA",
  },
  ErrorHeading: {
    textAlign: "center",
    my: "15px",
    fontWeight: "700",
  },
});

function ErrorBoundry() {
  const { classes } = useStyles();
  const navigate = useNavigate();

  return (
    <Box className={classes.Container}>
      <img src="/images/vortex.png" alt="logo" className={classes.Image} />
      <Typography variant="h4" className={classes.ErrorHeading}>
        Oops! An error has occurred in the application
      </Typography>
      <Typography
        variant="h6"
        sx={{
          minWidth: "60%",
          maxWidth: "800px",
          textAlign: "center",
        }}
      >
        Please try refreshing the page, returning to the homepage, or contacting the System Admin for assistance. We
        apologize for any inconvenience caused.
      </Typography>
      <ButtonUI
        variant="contained"
        color="info"
        sx={{ my: "15px" }}
        onClick={() => {
          navigate("/control-panel");
        }}
      >
        Go to home page
      </ButtonUI>
    </Box>
  );
}

export default React.memo(ErrorBoundry);
